import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25b8732a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { align: "center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "text-h5 font-weight-bold mb-4" }, " MEDCIRCLE steht für Datenschutz! ", -1))
const _hoisted_3 = {
  class: "mb-8",
  style: {"font-size":"15px"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'CookieBanner',
  setup(__props) {

const { t } = useI18n()
const showBanner = ref(false)
const smallWindow = ref(window.innerWidth < 500)

onMounted(() => {
  const decision = localStorage.getItem('cookies-decision')
  if (!decision) {
    showBanner.value = true
  }
})
onMounted(() => {
  window.addEventListener('resize', updateWindowSize)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateWindowSize)
})

const updateWindowSize = (): void => {
  smallWindow.value = window.innerWidth < 1000
}

const onDecisionMade = (decision: boolean) => {
  if (decision) {
    localStorage.setItem('cookies-decision', 'yes')
  } else {
    localStorage.setItem('cookies-decision', 'no')
  }
  showBanner.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: showBanner.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showBanner).value = $event)),
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, {
        border: "md",
        class: "pa-6 text-black mx-auto",
        color: "white",
        "max-width": !smallWindow.value ? '450px' : '300px',
        style: {"font-family":"Verdana, Geneva, Tahoma, sans-serif","border-radius":"5%"}
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_img, {
              src: require('../../../assets/main-logo.png'),
              width: "100px"
            }, null, 8, ["src"])
          ]),
          _hoisted_2,
          _createElementVNode("p", _hoisted_3, [
            _createTextVNode(" Bei MEDCIRCLE legen wir großen Wert auf Datenschutz! Wir verwenden Cookies, um zu lernen, wie wir Sie am besten erreichen können, ohne dabei persönliche Daten zu erfassen. Sie haben die Wahl, nur essentielle Cookies zu akzeptieren oder uns zu unterstützen, indem Sie alle Cookies akzeptieren, damit wir aus anonymisierten Daten lernen können. Unsere Datenschutzerklärung finden Sie "),
            _createVNode(_component_router_link, {
              to: "/privacy-policy",
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createTextVNode("hier")
              ]),
              _: 1
            }),
            _createTextVNode(".. Ganz gleich, wie Sie sich entscheiden: Herzlich willkommen bei MEDCIRCLE! "),
            _hoisted_4,
            _hoisted_5
          ]),
          _createVNode(_component_v_btn, {
            color: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (onDecisionMade(true))),
            block: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("Alle Cookies akzeptieren")
            ]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            class: "mt-2",
            color: "secondary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (onDecisionMade(false))),
            block: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode("Nur essentielle Cookies akzeptieren")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["max-width"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})